import '@styles/components/appCiviStationconStru.less';

const NewThree = () => {
  return (
    <div className={'app-display-desc'}>
      <div className={'padding-top'}>
        <div className={'content-title'}>
          <p className={'text'}>
            中国公路学会“天工杯”大赛
            <br />
            公益讲座系列合集
          </p>
        </div>
        <div className={'content-introduction'}>
          <p>
            处于数字化洪流中，数字孪生、智慧城市、智慧交通等相关技术已逐渐应用于基础设施建设领域。中国公路学会协同BENTLEY软件(北京)有限公司、北京跨世纪软件技术有限公司于6月举办四期“天工杯”数字交通及智能建造技术应用大赛公益讲座，讲座邀请了行业内各领域的专家，聚焦数字交通和智慧城市等热点话题展开叙述。
          </p>
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <p className={'text'}>回放合辑</p>
          <span className={'line'} />
        </div>
        <div className={'margin5'}></div>
        <div className={'introduce'}>
          <span className={'title-list-sty'}>01</span>
          数字交通是智慧城市建设中的关键环节，对城市可持续发展与创新具有重要意义，深度契合“十四五”时期大力构建数字中国的发展目标。“天工杯”数字交通及智能建造技术应用大赛公益讲座第一期于6月9日14:30开播，主要围绕“数字交通与智慧城市”展开详述，扫描下方二维码或点击链接即可观看精彩回放。
        </div>
        <div className={'theme-title'}>本期聚焦主题：数字交通与智慧城市</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>BIM辅助城市智慧建设及协同管理应用</span>
          </div>
          <div className={'speech-title'}>苏交科集团股份有限公司 胡彦卿</div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>智慧公路数字底盘- BENTLEY公路行业信息化解决方案</span>
          </div>
          <div className={'speech-title'}>BENTLEY软件(北京)有限公司 陈晨</div>
        </div>
        <div className={'introduce'}>
          点击链接：
          <a href={'https://live.vhall.com/v3/lives/watch/300278922'}>
            https://live.vhall.com/v3/lives/watch/300278922
          </a>
          <br />
          即可观看高清回放！
        </div>
        <div className={'introduce'}>
          <span className={'title-list-sty'}>02</span>
          BIM是创建和使用“数字孪生”的工具，并取得很大的应用价值，在建设交通强国的过程中，数字孪生与BIM应用的结合还需不断深入探索。“天工杯”数字交通及智能建造技术应用大赛公益讲座第二期于6月16日14:30开播，主要围绕“数字孪生与BIM应用”展开详述，扫描下方二维码或点击链接即可观看精彩回放
        </div>
        <div className={'theme-title'}>本期聚焦主题：数字孪生与BIM应用</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>打造本地化数字孪生底座，深化BIM应用</span>
          </div>
          <div className={'speech-title'}>北京跨世纪软件技术有限公司 崔杨</div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>高速公路三维数字孪生成套关键技术研究与工程应用</span>
          </div>
          <div className={'speech-title'}>广西交通设计集团 王长海</div>
        </div>
        <div className={'introduce'}>
          点击链接：
          <a href={'https://live.vhall.com/v3/lives/subscribe/322390656'}>
            https://live.vhall.com/v3/lives/subscribe/322390656
          </a>
          <br />
          即可观看高清回放！
        </div>
        <div className={'introduce'}>
          <span className={'title-list-sty'}>03</span>
          数字建造是基于建筑信息模型（BIM）的数字化应用，加快推进以BIM数字化技术为基础的智能建造信息化水平建设是一项艰巨而长期的任务。“天工杯”数字交通及智能建造技术应用大赛公益讲座第三期于6月23日14:30开播，扫描下方二维码或点击链接即可观看精彩回放。
        </div>
        <div className={'theme-title'}>本期聚焦主题：数字建造与BIM应用</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>深中通道项目数字建造技术探索与应用</span>
          </div>
          <div className={'speech-title'}>深中通道管理中心 刘健</div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>合枞高速全生命周期BIM技术的应用与实践</span>
          </div>
          <div className={'speech-title'}>安徽省合枞高速公路有限责任公司 朱玉</div>
        </div>
        <div className={'introduce'}>
          点击链接：
          <a href={'https://live.vhall.com/v3/lives/subscribe/573100018'}>
            https://live.vhall.com/v3/lives/subscribe/573100018
          </a>
          <br />
          即可观看高清回放！
        </div>
        <div className={'introduce'}>
          <span className={'title-list-sty'}>04</span>
          随着BIM技术在建筑工程领域的普及推广，给BIM技术的广泛应用创造良好的发展环境，并进一步规范行业发展，一套
          BIM技术相关的行业标准体系变得尤为重要。“天工杯”数字交通及智能建造技术应用大赛公益讲座第四期于6月30日14:30开播，扫描下方二维码或点击链接即可观看精彩回放。
        </div>
        <div className={'theme-title'}>本期聚焦主题：标准体系与数据环境</div>
        <div className={'introduce'}>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>中国公路学会BIM标准体系的建立</span>
          </div>
          <div className={'speech-title'}>中交第二公路勘察设计研究院有限公司 王欣南</div>
          <div className={'flex'}>
            <span className={'list-d'}>●</span>
            <span className={'list-text'}>
              搭建CDE互连数据环境助力数字化资产管理和数字化运维管理
            </span>
          </div>
          <div className={'speech-title'}>BENTLEY软件(北京)有限公司 唐汝昌</div>
        </div>
        <div className={'introduce'}>
          点击链接：
          <a href={'https://live.vhall.com/v3/lives/subscribe/744860558'}>
            https://live.vhall.com/v3/lives/subscribe/744860558
          </a>
          <br />
          即可观看高清回放！
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>大赛简介</p>
          <span className={'line'} />
        </div>
        <div className={'margin5'}></div>
        <div className={'introduce'}>
          “天工杯”数字交通及智能建造技术应用大赛（以下简称大赛），旨在通过公路交通行业相关企业、高校数字化转型实践应用案例，引领行业企业和高校推进信息化建设，发现并培养更多的创新和应用型技术人才，推广数字孪生、安全监测、数字交付、智慧调度、物资监管、数字化养护等智能建造方法和创新管理模式的应用，推进新一代信息技术与交通产业化技术协同发展，推动数字化与智能建造全产业链的深度融合，提升公路基础设施数字化集成管理水平，助力智慧交通发展。
        </div>
      </div>
    </div>
  );
};

export default NewThree;
